import React, { useEffect, useState } from 'react';
import { ChatAI } from 'dx-chat-ai-client';
import { getConfigFromAPI } from './dynamic-config';

export function WidgetChatAI({ userId, lang, deviceType }) {
  if (typeof window === typeof undefined) {
    return null;
  }

  const [config, setConfig] = useState(null);
  const fixed = deviceType === 'mobile' ? { bottom: 20, right: 20 } : { bottom: 30, right: 40 };

  useEffect(() => {
    if (!config) {
      getConfigFromAPI({
        dialogWindow: true,
        portal: document.body,
        fixed,
        lang,
      })
        .then(setConfig)
        .catch(console.error);
    }
  }, []);

  if (!config || typeof config !== 'object' || !config.setup) {
    return null;
  }

  const { id, abort, allowedScopes, allowedSites, dialogWindow, portal, setup } = config;
  const { nodeId, queryParams, skill } = setup;

  return (
    <ChatAI
      id={id}
      lang={lang}
      abort={abort}
      fixed={fixed}
      portal={portal}
      allowedSites={allowedSites}
      dialogWindow={dialogWindow}
      allowedScopes={allowedScopes}
      setup={{
        skill,
        nodeId,
        queryParams: {
          ...queryParams,
          context_logged: !!userId,
        },
      }}
    />
  );
}
